import { PlayerStats } from './types';

// Discover actual team IDs from player data, since they may not match
// the match's homeTeamId/awayTeamId exactly
export const getPlayerTeamId = (p: PlayerStats): number | undefined => {
  return p.teamId || p.stats?.teamId || p.stats?.player?.currentTeamId || undefined;
};

export const formatStat = (value: number | undefined, decimals = 0): string => {
  if (value === undefined || value === null) return '-';
  return decimals > 0 ? value.toFixed(decimals) : String(value);
};
